import { request } from '@umijs/max';
import { RegulationType, UpdateBuiltInParams } from './type';

/**
 * 返回比对内置字符
 * @method GET
 */
export const getBuiltinChars = () => {
  return request<IRes<string[]>>('/supertext-java/diff/regulation/');
};

/**
 * 返回比对字符配置
 * @method GET
 */
export const getBuiltinCharsConfig = () => {
  return request<IRes<RegulationType>>('/supertext-java/diff/regulation/builtin_char/');
};

/**
 * 更新字符配置
 * @method PUT
 */
export const updateBuiltinChars = (data: UpdateBuiltInParams) => {
  return request<IRes<string>>('/supertext-java/diff/regulation/char_filter_out', {
    method: 'PUT',
    data,
  });
};
